export enum UserLanguage {
    English = 1,
    Norwegian = 2
}